module.exports = "https://static.wanderu.com/ui-react/_next/static/media/sad-chiku.d5ce2a21.svg";